/**
 * @file リーダーの「自動で再生」の入り切りを端末に覚える。
 *
 * @what: localStorage に真偽値を1つ持つ。資料ごとではなく端末ごとにする。
 * @why: 自動で鳴るかどうかは、その人がいまどこで読んでいるか (電車の中か、家か) で決まる
 *   もので、本の性質ではない。既定は切にする。※なぜならブラウザは操作なしの再生を
 *   止めるので、既定を入にすると「入っているのに鳴らない」状態から始まるためである。
 * @failure: localStorage が読めない端末では、その画面のあいだだけ覚える (切から始まる)。
 */

const KEY = "bb.study.reader.audioAutoplay";

/** 覚えている「自動で再生」の値 (覚えていなければ切)。 */
export function readAudioAutoplay(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

/** 「自動で再生」の値を覚える。 */
export function writeAudioAutoplay(on: boolean): void {
  try {
    window.localStorage.setItem(KEY, on ? "1" : "0");
  } catch {
    // 覚えられなくても、その画面のあいだは切り替えが効く
  }
}
